/* eslint-disable max-len */
import React, { FC } from "react";

type IProps = {
    width?: number;
    height?: number;
    color?: string;
};

const SvgComponent: FC<IProps> = ({ width = 24, height = 24, color }) => (
  <svg xmlns="http://www.w3.org/2000/svg" width={width} height={height} viewBox="0 0 24 25" fill="none">
    <path d="M3 9.73926L12 2.73926L21 9.73926V20.7393C21 21.2697 20.7893 21.7784 20.4142 22.1535C20.0391 22.5285 19.5304 22.7393 19 22.7393H5C4.46957 22.7393 3.96086 22.5285 3.58579 22.1535C3.21071 21.7784 3 21.2697 3 20.7393V9.73926Z" stroke="#908E8D" strokeWidth="1.8" strokeLinecap="round" strokeLinejoin="round"/>
    <path d="M9 22.7393V12.7393H15V22.7393" stroke="#908E8D" strokeWidth="1.8" strokeLinecap="round" strokeLinejoin="round"/>
  </svg>
);

export default SvgComponent;
